import { useState, useEffect, useRef, useCallback } from 'react';
import { ajax } from 'jquery';
import './index.css';
import CommitEditor from '../editor/editor';
import { useParams } from 'react-router-dom';

function replaceSpacesWithUnderscoresUsingReplaceAll(str: string): string {
    return str.replaceAll(' ', '_');
}

function formatDate(dateString: string): string {
    if (!dateString) return '';

    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
}

export default function Note() {
    const [loading, setLoading] = useState<boolean>(true);
    const [note, setNote] = useState<any>(null);
    const [shareLinkCopied, setShareLinkCopied] = useState<boolean>(false);
    const [likedNoteIds, setLikedNoteIds] = useState<number[]>([]);
    const { noteId } = useParams();
    const [error, setError] = useState<string>('');
    
    // 评论相关状态
    const [comments, setComments] = useState<any[]>([]);
    const [newComment, setNewComment] = useState<string>('');
    const [submittingComment, setSubmittingComment] = useState<boolean>(false);
    // 加载数据的函数
    const loadNote = async () => {
        try {
            setLoading(true);
            setError('');
            const result = await ajax({
                method: "GET",
                url: `/api/v1/countryball_card/note/id/${noteId}`,
            });
            setNote(result);
        } catch (err: any) {
            console.error('Failed to load note:', err);
            if (err.status === 403) {
                setError('这是一篇未公开的日记，无法查看');
            } else {
                setError('加载日记失败，请稍后重试');
            }
        } finally {
            setLoading(false);
        }
    };

    // 加载评论的函数
    const loadComments = async () => {
        try {
            const result = await ajax({
                method: "GET",
                url: `/api/v1/countryball_card/note/${noteId}/comments`,
            });
            setComments(result);
        } catch (err: any) {
            console.error('Failed to load comments:', err);
        }
    };

    // 初始加载
    useEffect(() => {
        loadNote();
        loadComments();
    }, [noteId]);

    const handleLike = async () => {
        try {
            const result = await ajax({
                method: "POST",
                url: `/api/v1/countryball_card/note/${noteId}/like`,
            });
            setNote(result)
        } catch (err: any) {
            console.error('Failed to like/unlike note:', err);
            // 如果返回401或403错误，说明未登录或权限不足，跳转到登录页面
            if (err.status === 401 || err.status === 403) {
                window.location.href = '/login';
            } else {
                alert('点赞失败，请稍后重试');
            }
        }
    };

    const handleShare = async () => {
        try {
            // 记录分享
            const result = await ajax({
                method: "POST",
                url: `/api/v1/countryball_card/note/${noteId}/share`,
            });

            // 分享链接
            const shareUrl = `${window.location.origin}/note/${noteId}`;

            // 如果有原生分享API，使用它
            if (navigator.share) {
                await navigator.share({
                    title: '国家球日记',
                    text: '看看这篇有趣的国家球日记！',
                    url: shareUrl,
                });
            } else {
                // 否则复制链接到剪贴板
                navigator.clipboard.writeText(shareUrl).then(() => {
                    setShareLinkCopied(true);
                    setTimeout(() => setShareLinkCopied(false), 2000);
                });
            }
        } catch (err) {
            console.error('Failed to share note:', err);
        }
    };

    // 提交评论
    const handleSubmitComment = async () => {
        if (!newComment.trim() || submittingComment) return;
        
        try {
            setSubmittingComment(true);
            const result = await ajax({
                method: "POST",
                url: `/api/v1/countryball_card/note/${noteId}/comments`,
                data: {
                    content: newComment.trim()
                }
            });
            
            // 重新加载评论列表
            await loadComments();
            setNewComment('');
        } catch (err: any) {
            console.error('Failed to submit comment:', err);
            // 如果返回401或403错误，说明未登录或权限不足，跳转到登录页面
            if (err.status === 401 || err.status === 403) {
                window.location.href = '/login';
            } else {
                alert('评论发送失败，请稍后重试');
            }
        } finally {
            setSubmittingComment(false);
        }
    };

    return (
        <div className='page-wrap note-detail-page'>
            <div className="note-detail-page-content">
                {loading ? (
                    <div className="loading-indicator">
                        <p className="shufa-text">加载中...</p>
                    </div>
                ) : error ? (
                    <div className="error-message">
                        <p className="shufa-text">{error}</p>
                        <a className="back-button shufa-text" href='/featured'>返回</a>
                    </div>
                ) : note && note.comic && (
                    <div className="comic-modal-content">
                        <div className="user-info-area">
                            {note.user.avatarCountry &&
                                <div className="user-avatar">
                                    <img
                                        className='ball-pic'
                                        src={`https://oss.usecubes.cn/countryballs/new_balls/${replaceSpacesWithUnderscoresUsingReplaceAll(note.user.avatarCountry.name_en)}.png`}
                                        alt={note.country}
                                    />
                                    <img
                                        className='face-pic'
                                        src={`https://oss.usecubes.cn/countryballs/faces/${note.user.avatarExpressionType + 1 + note.user.avatarExpressionOrientation}.png`}
                                    />
                                </div>
                            }
                            <div className="note-author shufa-text">{note.user?.username || '匿名用户'} 的日记</div>
                        </div>
                        {/* <div className="comic-modal-header">
                            <h4 className="shufa-text">漫画</h4>
                        </div> */}
                        <div className="comic-display">
                            <CommitEditor
                                mode="view"
                                comicData={JSON.parse(note.comic)}
                            />
                        </div>

                        <div className="note-detail-note-item">


                            <div className="note-content">
                                <div className="note-avatar">
                                    <img
                                        className='ball-pic'
                                        src={`https://oss.usecubes.cn/countryballs/new_balls/${replaceSpacesWithUnderscoresUsingReplaceAll(note.country)}.png`}
                                        alt={note.country}
                                    />
                                    <img
                                        className='face-pic'
                                        src={`https://oss.usecubes.cn/countryballs/faces/${note.expressionType + 1 + note.expressionOrientation}.png`}
                                    />
                                </div>
                                <p className="shufa-text">{note.note}</p>
                            </div>

                            <div className="note-footer">
                                <div className="note-date shufa-text">{note.date || formatDate(note.created)}</div>

                                {/* 点赞和分享按钮 */}
                                <div className="note-actions">
                                    <div
                                        className={`action-button like-button shufa-text ${likedNoteIds.includes(note.id) ? 'liked' : ''}`}
                                        onClick={() => handleLike()}
                                    >
                                        <svg className="action-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="currentColor" />
                                        </svg>
                                        <span>{note.likes || 0}</span>
                                    </div>

                                    {note.isPublic === 1 && (
                                        <div
                                            className="action-button share-button shufa-text"
                                            onClick={() => handleShare()}
                                        >
                                            <svg className="action-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z" fill="currentColor" />
                                            </svg>
                                            <span>{note.shares || 0}</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* 评论区域 */}
                        <div className="comments-section">
                            <h3 className="comments-title shufa-text">评论 ({comments.length})</h3>
                            
                            {/* 评论输入框 */}
                            <div className="comment-input-section">
                                <textarea
                                    className="comment-input shufa-text"
                                    placeholder="写下你的评论..."
                                    value={newComment}
                                    onChange={(e) => setNewComment(e.target.value)}
                                    disabled={submittingComment}
                                />
                                <button
                                    className={`comment-submit-btn shufa-text ${!newComment.trim() || submittingComment ? 'disabled' : ''}`}
                                    onClick={handleSubmitComment}
                                    disabled={!newComment.trim() || submittingComment}
                                >
                                    {submittingComment ? '发送中...' : '发送评论'}
                                </button>
                            </div>

                            {/* 评论列表 */}
                            <div className="comments-list">
                                {comments.length === 0 ? (
                                    <div className="empty-comments shufa-text">
                                        还没有评论，来发表第一条评论吧！
                                    </div>
                                ) : (
                                    comments.map((comment) => (
                                        <div key={comment.id} className="comment-item">
                                            <div className="comment-header">
                                                <div className="comment-user-info">
                                                    {comment.user.avatarCountry && (
                                                        <div className="comment-user-avatar">
                                                            <img
                                                                className='ball-pic'
                                                                src={`https://oss.usecubes.cn/countryballs/new_balls/${replaceSpacesWithUnderscoresUsingReplaceAll(comment.user.avatarCountry.name_en)}.png`}
                                                                alt={comment.user.avatarCountry.name}
                                                            />
                                                            <img
                                                                className='face-pic'
                                                                src={`https://oss.usecubes.cn/countryballs/faces/${comment.user.avatarExpressionType + 1 + comment.user.avatarExpressionOrientation}.png`}
                                                            />
                                                        </div>
                                                    )}
                                                    <span className="comment-username shufa-text">{comment.user.username}</span>
                                                </div>
                                                <span className="comment-date shufa-text">{formatDate(comment.created)}</span>
                                            </div>
                                            <div className="comment-content shufa-text">
                                                {comment.content}
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                    </div>
                )}
                {/* 分享链接复制提示 */}
                {shareLinkCopied && (
                    <div className="share-notification">
                        <p className="shufa-text">链接已复制到剪贴板</p>
                    </div>
                )}
            </div>
        </div>
    );
}